var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "bar__li" },
    [
      _c("a", { ref: "anchor", class: _vm.buttonClass, attrs: { href: "#" } }, [
        _c("span", [_vm._t("default")], 2)
      ]),
      _vm._v(" "),
      _vm._t("block")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }